import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";
import colors from "app/colors";

const ClosedCircleCheckIcon = (props: IconProps) => (
  <Icon w="32px" h="32px" viewBox="0 0 32 32" {...props}>
    <circle cx="16" cy="16" r="16" />
    <path
      d="M8 16.0526L13.6168 21.5992L24 11.1992"
      stroke={colors.white}
      strokeWidth="2"
    />
  </Icon>
);

export default memo(ClosedCircleCheckIcon);
